module.exports = __webpack_public_path__ + "static/timeline2016-1-a241b0bad29240f412f5543fc0bb7fbf.jpeg";